import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { I18N_CONFIG } from './i18n/config'
import { getStoredLanguage, getBrowserLanguage } from './i18n/utils'

// Import translation files
import zhTW from '../../public/locales/zh-TW/common.json'
import zhCN from '../../public/locales/zh-CN/common.json'
import en from '../../public/locales/en/common.json'

const resources = {
  'zh-TW': {
    common: zhTW
  },
  'zh-CN': {
    common: zhCN
  },
  en: {
    common: en
  }
}

// 立即初始化 i18n 以避免水合问题
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: I18N_CONFIG.defaultLanguage, // 初始使用默认语言避免水合问题
    fallbackLng: I18N_CONFIG.defaultLanguage,
    defaultNS: 'common',
    ns: I18N_CONFIG.namespaces,
    
    interpolation: {
      escapeValue: false
    },
    
    react: {
      useSuspense: false
    }
  })

// 单例模式确保只初始化一次
let isInitialized = false

export async function initializeI18n() {
  if (isInitialized) {
    return i18n
  }

  // 获取初始语言：优先级 localStorage > 浏览器语言 > 默认语言
  const storedLanguage = getStoredLanguage()
  const defaultLanguage = storedLanguage || getBrowserLanguage()

  // 更新语言设置
  if (defaultLanguage !== i18n.language) {
    await i18n.changeLanguage(defaultLanguage)
  }
  
  isInitialized = true
  return i18n
}

// 为了向后兼容，仍然导出 i18n 实例
export default i18n